export default __webpack_public_path__ + "media/color/gbyte-fb95d0bf.svg";